import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { audioVideoSliceActions } from "../../Store/Slices/AudioVideoSlice";

// Global variables

const AudioButton = (props) => {
  const dispatch = useDispatch();

  const [soundData, setSoundData] = useState(null);
  const [isFinished, setIsFinished] = useState(false);
  const [uri, setUri] = useState(null);

  // Redux state
  let currentAudioSrc = useSelector(
    (state) => state.audioVideo.currentAudioSrc
  );
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { serverRole } = useSelector((state) => state.defs);

  useEffect(() => {
    let innerFun = async () => {
      if (props) {
        let uri;
        let usernamesplit = userInfo.username.split("@");
        let alias = usernamesplit[usernamesplit.length - 1];
        let port = sessionStorage.getItem("port_data")
          ? sessionStorage.getItem("port_data").split(",")
          : process.env.REACT_APP_PORT_DATA.split(",");
        if (props.expertAudio) {
          uri = `${sessionStorage.getItem("media_url")}audio/${
            props.expertAudio
          }`;
        } else if (props.wordAudio) {
          uri = `${sessionStorage.getItem("media_url")}words_media/audio/${
            props.wordAudio
          }`;
        } else if (props.localUri) {
          if (props.localUri.includes("blob:")) {
            uri = `${props.localUri}`;
          } else {
            let userAnswerAudio = props.localUri.split("/");
            userAnswerAudio = userAnswerAudio[userAnswerAudio.length - 1];
            if (serverRole && serverRole.toLowerCase() == "web_host") {
              uri = `${
                sessionStorage.getItem("site_ip")
                  ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                  : process.env.REACT_APP_SERVER_API
              }/media/userUploadedData/${alias}/${userAnswerAudio}`;
              const result = await fetch(uri, {
                mode: "cors",
                method: "HEAD",
              }).catch((err) => {
                console.log("okerr");
              });
              console.log("result", result);
              if (!result.ok) {
                uri = `${
                  sessionStorage.getItem("site_ip")
                    ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                    : process.env.REACT_APP_SERVER_API
                }/media/userUploadedData/default/${userAnswerAudio}`;
                const result1 = await fetch(uri, {
                  mode: "cors",
                  method: "HEAD",
                }).catch((err) => {
                  console.log("okerr");
                });
                if (!result1.ok) {
                  uri = `${
                    sessionStorage.getItem("site_ip")
                      ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                      : process.env.REACT_APP_SERVER_API
                  }/media_2024/userUploadedData/${userAnswerAudio}`;
                }
              }
            } else {
              uri = `${
                sessionStorage.getItem("site_ip")
                  ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                  : process.env.REACT_APP_SERVER_API
              }/media/userUploadedData/${userAnswerAudio}`;
            }
          }
        } else if (props.broadcastUri) {
          uri = `${
            sessionStorage.getItem("site_ip")
              ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
              : process.env.REACT_APP_SERVER_API
          }/media/userUploadedData/broadCast/${props.broadcastUri}`;
          console.log("uri", uri);
        } else {
          if (serverRole && serverRole.toLowerCase() == "web_host") {
            uri = `${
              sessionStorage.getItem("site_ip")
                ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                : process.env.REACT_APP_SERVER_API
            }/media/userUploadedData/${alias}/${props.userAnswer}`;
            const result = await fetch(uri, {
              mode: "cors",
              method: "HEAD",
            }).catch((err) => {
              console.log("okerr");
            });
            console.log("result", result);
            if (!result.ok) {
              uri = `${
                sessionStorage.getItem("site_ip")
                  ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                  : process.env.REACT_APP_SERVER_API
              }/media/userUploadedData/default/${props.userAnswer}`;
              const result1 = await fetch(uri, {
                mode: "cors",
                method: "HEAD",
              }).catch((err) => {
                console.log("okerr");
              });
              if (!result1.ok) {
                uri = `${
                  sessionStorage.getItem("site_ip")
                    ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                    : process.env.REACT_APP_SERVER_API
                }/media_2024/userUploadedData/${props.userAnswer}`;
              }
            }
          } else {
            uri = `${
              sessionStorage.getItem("site_ip")
                ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                : process.env.REACT_APP_SERVER_API
            }/media/userUploadedData/${props.userAnswer}`;
          }
        }

        setUri(uri);
        props.playStatus(false);
        const sound = new Audio(uri);
        if(props.volume){
          sound.volume = props.volume;
        }
        sound.playbackRate = props.playbackValue ? props.playbackValue : 1;
        sound.addEventListener("loadedmetadata", () => {
          if (props.metadata) {
            props.metadata(sound.duration);
          }
        });
        sound.addEventListener("ended", () => {
          props.playStatus(false, true);
          setIsFinished(true);
        });

        if (props.onupdate) {
          sound.ontimeupdate = () => {
            if (!isNaN(sound.duration)) {
              let val = (sound.currentTime / sound.duration) * 100;
              props.onupdate({
                progress: val,
                currentTime: sound.currentTime,
                duration: sound.duration,
              });
            }
          };
        }
        setSoundData(sound);
      }
    };
    innerFun();
  }, [
    props.expertAudio,
    props.userAnswer,
    props.localUri,
    props.wordAudio,
    userInfo,
  ]);

  useEffect(() => {
    if (props.playbackValue && soundData) {
      soundData.playbackRate = props.playbackValue ? props.playbackValue : 1;
    }
  }, [props.playbackValue, soundData]);

  useEffect(() => {
    return () => {
      if (soundData) {
        props.playStatus(false, false, true);
        soundData.pause();
        soundData.currentTime = 0;
      }
      dispatch(audioVideoSliceActions.resetState());
    };
  }, [soundData]);

  useEffect(() => {
    if (currentAudioSrc != uri && soundData) {
      soundData.pause();
      props.playStatus(false, false, true);
    }
  }, [currentAudioSrc]);

  const playExpertAudio = async () => {
    if (!props.disabled) {
      dispatch(audioVideoSliceActions.setCurrentAudioSrc(uri));
      if (!soundData.paused) {
        await soundData.pause();
        props.playStatus(false);
      } else {
        soundData.play();
        props.playStatus(true);
        dispatch(audioVideoSliceActions.setAudioIsPlaying(false));
      }
    } else {
      return false;
    }
  };

  return (
    <>
      <span
        onClick={playExpertAudio}
        style={props.containerStyle ? props.containerStyle : {}}
      >
        {props.children}
      </span>
    </>
  );
};

export default AudioButton;
